import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/product/install-app-banner/banner-m.webp?url")